// extracted by mini-css-extract-plugin
export default {"Dropdown-menu":"Tooltip_Dropdown-menu__MeKok","component":"Tooltip_component__SzSnq","icon":"Tooltip_icon__PLFXS","tooltip":"Tooltip_tooltip__dtEKt","dark":"Tooltip_dark__9BbBM"};